import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import LifeHero from "./LifeHero";
import EmergencySupport from "./EmergencySupport";
import MedicalFundraising from "./MedicalFundraising";
import MedicalFundraisingCategories from "./MedicalFundraisingCategories";
import BenefitsOfCrowdfunding from "./BenefitsOfCrowdfunding";
import Testimonials from "./Testimonials";
import Faq from "../../components/common/CampaignDetailPageComponents/Faq";
import { fetchCmsHomeAction } from "../../store/slices/cmsSlice";

const LifePage = () => {
  const dispatch = useDispatch();
  const cmsHome = useSelector((state) => state.cms.home);

  useEffect(() => {
    if (!cmsHome) dispatch(fetchCmsHomeAction());
  }, [cmsHome, dispatch]);

  return (
    <Box>
      <LifeHero />
      <Box id="medical-emergencies" component="section" aria-label="Medical Emergency">
        <EmergencySupport />
      </Box>
      <MedicalFundraising />
      <MedicalFundraisingCategories />
      <BenefitsOfCrowdfunding />
      <Testimonials />
      <Box sx={{ width: "94.44%", maxWidth: "1440px", mx: "auto" }}>
        <Faq />
      </Box>
    </Box>
  );
};

export default LifePage;


